define('constants/billingMethodConstants',[],() => {
    return Object.freeze({
        CreditCard: 1,
        Ach: 2,
        Invoice: 3
    });
});

